<div class="header_hero-bg"></div>

<div class="report-trade-container container-fluid">
  <div class="row report_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 report_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="report_header-information__sub-header" id="report-title">ACTIVE CONTACTS</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding">
          <div class="line-break"></div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 view-edit-collateral-header">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 view-edit-collateral-tab">
          <div class="row">
            <div
              class="col-2 col-sm-2 col-md-2 col-lg-2 view-edit-collateral-text"
              id="dealer-details"
              (click)="showDealerSelection()"
            >
              <span
                class="contact-grid-selection-dealer"
                [ngClass]="{ 'selected-type-font': showDealer }"
                >Dealer's List</span
              >
              <div
                class="line-break-tab-fannie"
                [ngClass]="{ 'selected-type-border': showDealer }"
              ></div>
            </div>
            <div
              class="col-2 col-sm-2 col-md-2 col-lg-2 view-edit-collateral-text"
              id="org-details"
              (click)="showOrgSelection()"
            >
              <span class="contact-grid-selection-org" [ngClass]="{ 'selected-type-font': showOrg }"
                >Org's List</span
              >
              <div class="line-break-tab" [ngClass]="{ 'selected-type-border': showOrg }"></div>
            </div>
            <div class="visible-md-5 col-12 col-sm-12 col-md-8 col-lg-8 pr-0">
              <div class="pdf-excel float-end">
                <button
                  class="button fm-secondary-button"
                  (click)="downloadReport()"
                  id="excel-button"
                >
                  DOWNLOAD EXCEL
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 pl-0 pr-0">
            <button class="button fm-secondary-button col-12" (click)="downloadReport()" id="excel-button-sm">DOWNLOAD EXCEL</button>
          </div> -->
        </div>
      </div>
      <div class="line-break-tab-grid collatereal-analyzer-border"></div>

      <div class="row issuance-table">
        <ng-container *ngIf="showDealer">
          <div class="fm-cdx-table" id="st-user-table">
            <table class="fm-cdx-table__static">
              <thead>
                <tr class="th_row">
                  <th
                    class="th_column th_sortable-column sortable-column"
                    (click)="sortByGridByColumnName('cusip')"
                  >
                    <span>Org Name</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column"
                    (click)="sortByGridByColumnName('poolNumber')"
                  >
                    <span>First Name</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column"
                    (click)="sortByGridByColumnName('prefixCode')"
                  >
                    <span>Last Name</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column"
                    (click)="sortByGridByColumnName('coupon')"
                  >
                    <span>UserId</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column amount-align"
                    (click)="sortByGridByColumnName('issuedAmount')"
                  >
                    <span>phoneNumber</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column amount-align"
                    (click)="sortByGridByColumnName('issuedAmount')"
                  >
                    <span>Email</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column amount-align"
                    (click)="sortByGridByColumnName('issuedAmount')"
                  >
                    <span>Org Id</span>
                  </th>
                  <th
                    class="th_column th_sortable-column sortable-column amount-align"
                    (click)="sortByGridByColumnName('issuedAmount')"
                  >
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="td_row issuance-table-header"
                  *ngFor="let contactDetail of contactDetails; trackBy: trackByIdentity"
                >
                  <td class="td_cell">{{ contactDetail?.orgName }}</td>
                  <td class="td_cell">{{ contactDetail?.dealerFirstName }}</td>
                  <td class="td_cell">{{ contactDetail?.dealerLastName }}</td>
                  <td class="td_cell">{{ contactDetail?.userId }}</td>
                  <td class="td_cell">{{ contactDetail?.phoneNumber }}</td>
                  <td class="td_cell">{{ contactDetail?.email }}</td>
                  <td class="td_cell">{{ contactDetail?.orgId }}</td>
                  <td class="td_cell">{{ contactDetail?.contactStatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="showOrg">
          <div class="fm-cdx-table" id="st-org-table">
            <table class="fm-cdx-table__static">
              <thead>
                <tr class="th_row">
                  <th class="th_column th_sortable-column sortable-column">
                    <span>Org Name</span>
                  </th>
                  <th class="th_column th_sortable-column sortable-column">
                    <span>Dealer Count</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="td_row issuance-table-header"
                  *ngFor="let orgDetail of orgDetails; trackBy: trackByIdentity"
                >
                  <td class="td_cell">{{ orgDetail?.orgName }}</td>
                  <td class="td_cell">{{ orgDetail?.dealerCount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
